import { render, staticRenderFns } from "./ImportarXmlCargo.vue?vue&type=template&id=40be8b6a"
import script from "./ImportarXmlCargo.vue?vue&type=script&lang=js"
export * from "./ImportarXmlCargo.vue?vue&type=script&lang=js"
import style0 from "./ImportarXmlCargo.vue?vue&type=style&index=0&id=40be8b6a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports